import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useState } from "react";
import { cx } from "../lib/cx.js";
export function Tooltip({ content, children }) {
    const id = useId();
    const [open, setOpen] = useState(false);
    return (_jsxs("span", { className: "evolua-tooltip", onMouseEnter: () => setOpen(true), onMouseLeave: () => setOpen(false), onFocus: () => setOpen(true), onBlur: () => setOpen(false), children: [_jsx("span", { "aria-describedby": open ? id : undefined, children: children }), open ? (_jsx("span", { id: id, role: "tooltip", className: cx("evolua-tooltip__box"), children: content })) : null] }));
}
export function Avatar({ name, src, size = "md", }) {
    const initials = name
        .split(/\s+/)
        .slice(0, 2)
        .map((p) => p[0]?.toUpperCase() ?? "")
        .join("");
    return (_jsx("span", { className: cx("evolua-avatar", `evolua-avatar--${size}`), "aria-hidden": false, title: name, children: src ? _jsx("img", { src: src, alt: "", className: "evolua-avatar__img" }) : initials || "?" }));
}
export function AvatarGroup({ names }) {
    return (_jsx("span", { className: "evolua-avatar-group", children: names.slice(0, 4).map((n) => (_jsx(Avatar, { name: n, size: "sm" }, n))) }));
}
//# sourceMappingURL=Tooltip.js.map